import React from 'react';

export default function PagePlaceholder({ badge, title, description, children }) {
  return (
    <main className="flex-grow w-full max-w-7xl mx-auto p-4 md:p-6 space-y-4 relative">
      <section className="w-full rounded-[32px] border border-white/10 bg-slate-950/55 p-8 shadow-[0_30px_120px_rgba(15,23,42,0.55)] backdrop-blur-md md:p-12">
        <div className="inline-flex rounded-full border border-cyan-400/30 bg-cyan-500/10 px-4 py-1 text-xs font-bold uppercase tracking-[0.28em] text-cyan-200">
          {badge}
        </div>
        <h1 className="max-w-3xl font-serif text-4xl leading-tight text-white md:text-5xl">
          {title}
        </h1>
        <p className="mt-5 max-w-2xl text-base leading-7 text-slate-300 md:text-lg">
          {description}
        </p>
        <div className="mt-8 grid gap-4 text-sm text-slate-300 md:grid-cols-2">
          {children}
        </div>
      </section>
    </main>
  );
}